/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerGetMeQueryResponse,
  TelegramUsersControllerGetMe401,
} from '../types/TelegramUsersControllerGetMe.ts';

function getTelegramUsersGetMeUrl() {
  const res = { method: 'GET', url: `/api/telegram/users/me` as const };
  return res;
}

/**
 * {@link /api/telegram/users/me}
 */
export async function telegramUsersGetMe(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramUsersControllerGetMeQueryResponse,
    ResponseErrorConfig<TelegramUsersControllerGetMe401>,
    unknown
  >({ method: 'GET', url: getTelegramUsersGetMeUrl().url.toString(), ...requestConfig });
  return res.data;
}
